import * as React from 'react';

const CalendarNumberSale = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
  >
    <mask
      id='mask0_7799_13595'
      style={{ maskType: 'luminance' }}
      maskUnits='userSpaceOnUse'
      x='0'
      y='0'
      width='24'
      height='24'
    >
      <path d='M24 0H0V24H24V0Z' fill='white' />
    </mask>
    <g mask='url(#mask0_7799_13595)'>
      <path
        d='M20.0417 4.5H18.75V2.25H16.5V4.5H7.5V2.25H5.25V4.5H3.95833C2.6025 4.5 1.5 5.6025 1.5 6.95833V17.2942C1.5 18.5783 2.50333 19.6558 3.785 19.7467L19.8683 20.8842C19.9258 20.8883 19.9833 20.89 20.04 20.89C20.6592 20.89 21.2625 20.6542 21.7175 20.23C22.215 19.7667 22.5 19.1108 22.5 18.4317V6.95833C22.5 5.6025 21.3975 4.5 20.0417 4.5ZM20.25 18.4317C20.25 18.5067 20.2142 18.5558 20.1833 18.5842C20.1533 18.6125 20.1008 18.6442 20.0267 18.64L3.94333 17.5025C3.835 17.495 3.75 17.4033 3.75 17.295V6.95917C3.75 6.84417 3.84333 6.75083 3.95833 6.75083H20.0417C20.1567 6.75083 20.25 6.84417 20.25 6.95917V18.4325V18.4317Z'
        fill='var(--colorIconPrimary)'
      />
      <path
        d='M14.25 13.5L15 15.75H18L17.25 13.5H14.25Z'
        fill='var(--colorIconPrimary)'
      />
      <path
        d='M10.1113 13.5L10.8613 15.75H13.8613L13.1113 13.5H10.1113Z'
        fill='var(--colorIconPrimary)'
      />
      <path
        d='M6 13.5L6.75 15.75H9.75L9 13.5H6Z'
        fill='var(--colorIconPrimary)'
      />
      <path
        d='M14.25 9L15 11.25H18L17.25 9H14.25Z'
        fill='var(--colorIconPrimary)'
      />
      <path
        d='M10.1113 9L10.8613 11.25H13.8613L13.1113 9H10.1113Z'
        fill='var(--colorIconPrimary)'
      />
      <path d='M6 9L6.75 11.25H9.75L9 9H6Z' fill='var(--colorIconPrimary)' />
    </g>
  </svg>
);

export default CalendarNumberSale;
